import React, { useCallback, useMemo } from 'react';
import FeaturesContext, { Features } from 'context/FeaturesContext';
import { useLocalStorage } from 'services/hooks';
import { FeaturesProviderProps } from './FeaturesProvider.props';

const EMPTY_FEATURES: Features = {};

export const FeaturesProvider = ({ children }: FeaturesProviderProps) => {
  const [features, setFeatures, , areFeaturesReady] = useLocalStorage<Features>('features', EMPTY_FEATURES);

  const toggleFeature = useCallback(
    (key: string) => {
      setFeatures(prev => ({ ...prev, [key]: !prev[key] }));
    },
    [setFeatures]
  );

  const featuresSignature = useMemo(() => JSON.stringify(features), [features]);

  const contextFeatures = useMemo(
    () => JSON.parse(featuresSignature) as Features,
    [featuresSignature]
  );

  const contextValue = useMemo(
    () => ({ features: contextFeatures, areFeaturesReady, toggleFeature }),
    [areFeaturesReady, contextFeatures, toggleFeature]
  );

  return <FeaturesContext.Provider value={contextValue}>{children}</FeaturesContext.Provider>;
};
